import {Menu, MenuItem} from "@mui/material";
import {Done} from "@mui/icons-material";
import React from "react";

export interface IMenuItem {
    onClick: () => void
    text: string
    tick?: boolean
    title: string
}
interface IBuildModeMenu {
    menu: IMenuItem[]
    onClose: () => void
    open: boolean
    parent: HTMLElement
}
export default function ModeMenu({menu, onClose, open, parent}: IBuildModeMenu) {
    const onClick = (item: IMenuItem) => () => {
        item.onClick();
        onClose();
    }
    return (
        <Menu open={open} onClose={onClose} anchorEl={parent}>
            {menu.map((item, index) =>
                <MenuItem key={index} onClick={onClick(item)} title={item.title}>
                    {item.text}
                    {item.tick && <Done sx={{marginLeft: 2}}/>}
                </MenuItem>
            )}
        </Menu>
    );
}
